/**
 * Initialize Matomo Analytics dynamically
 * This function should be called once when the app loads
 */
export const initializeMatomo = () => {
  // Check if Matomo is enabled via environment variable
  const isEnabled = process.env.REACT_APP_MATOMO_ENABLED === 'true';
  
  if (!isEnabled) {
    return;
  }

  // Get configuration from environment variables
  const matomoUrl = process.env.REACT_APP_MATOMO_URL || 'https://analytics.intuitiveapps.com/';
  const siteId = process.env.REACT_APP_MATOMO_SITE_ID || '9';
  const cookieDomain = process.env.REACT_APP_MATOMO_COOKIE_DOMAIN || '*.dev.deephire.ai';
  const domains = process.env.REACT_APP_MATOMO_DOMAINS 
    ? process.env.REACT_APP_MATOMO_DOMAINS.split(',').map(d => d.trim())
    : ['*.dev.deephire.ai', '*.www.dev.deephire.ai'];

  // Initialize Matomo
  var _paq = window._paq = window._paq || [];

  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
  _paq.push(["setCookieDomain", cookieDomain]);
  _paq.push(["setDomains", domains]);
  _paq.push(["enableCrossDomainLinking"]);
  _paq.push(["disableCampaignParameters"]);
  _paq.push(["setDoNotTrack", true]);
  _paq.push(["disableCookies"]);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);

  // Load Matomo script
  (function() {
    var u = matomoUrl;
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', siteId]);
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true; 
    g.src = u + 'matomo.js'; 
    s.parentNode.insertBefore(g, s);
  })();
};

/**
 * Create noscript fallback image for Matomo
 * This should be added to the HTML for users with JavaScript disabled
 */
export const getMatomoNoscript = () => {
  const isEnabled = process.env.REACT_APP_MATOMO_ENABLED === 'true';
  
  if (!isEnabled) {
    return null;
  }

  const matomoUrl = process.env.REACT_APP_MATOMO_URL || 'https://analytics.intuitiveapps.com/';
  const siteId = process.env.REACT_APP_MATOMO_SITE_ID || '9';

  return (
    <noscript>
      <p>
        <img 
          referrerPolicy="no-referrer-when-downgrade" 
          src={`${matomoUrl}matomo.php?idsite=${siteId}&rec=1`} 
          style={{ border: 0 }} 
          alt="" 
        />
      </p>
    </noscript>
  );
};

